import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createStyles, makeStyles } from '@applyboard/ui-components';
export var useStyle = makeStyles(function (theme) {
  var _cardStyle;
  return createStyles({
    cardStyle: (_cardStyle = {
      width: function width(_ref) {
        var fullWidth = _ref.fullWidth;
        return fullWidth ? '100%' : "calc((100% - ".concat(theme.spacing(4), "px)/2)");
      },
      minWidth: '352px'
    }, _defineProperty(_cardStyle, '&:not(:last-child)', _defineProperty({
      marginRight: theme.spacing(4),
      marginBottom: theme.spacing(4)
    }, theme === null || theme === void 0 ? void 0 : theme.breakpoints.down('sm'), {
      marginRight: 0
    })), _defineProperty(_cardStyle, theme === null || theme === void 0 ? void 0 : theme.breakpoints.down('md'), {
      width: '100% !important',
      minWidth: '100%'
    }), _defineProperty(_cardStyle, theme === null || theme === void 0 ? void 0 : theme.breakpoints.down('sm'), {
      width: '100% !important',
      minWidth: '100%'
    }), _cardStyle)
  });
});